export default "__VITE_ASSET__DpvIfFi1__"